import { HTTP_AP_ListLenderGroups_ForTable_Request_Filter } from '@api-new/mortgageservice';
import { LenderGroupTableRowModel } from '@platform/lender-group/pages/lender-group-table/models/lender-group-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const lenderGroupTableFilterDefaults: HTTP_AP_ListLenderGroups_ForTable_Request_Filter = { name: undefined };

export const lenderGroupTableRowDefinition: TableRowDefinitionModel<LenderGroupTableRowModel>[] = [
  {
    columnLabel: 'Group name',
    columnKey: 'name',
    type: RowDefinitionTypeEnum.Text,
  },
  {
    columnLabel: 'Lenders',
    columnKey: 'lenders',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '10rem',
      max: '50rem',
    },
  },
];
